import React, { useState, useContext, useEffect } from 'react';
import "./TrackSalesOrder.css";
import {
  checkInputValidity
} from "./../../Utility/utility";
import TrackingDetails from "./TrackingDetails/TrackingDetails";
import {
  getSalesOrderDetais
} from "../../Services/Services";
import { SalesContext } from "../../Context/SalesContext";
import {
  tagOnSOPageLoad,
  tagOnSODetailsPageLoad,
  tagOnSOTechnicalError,
  tagOnSODetailsPageErrorLoad
} from "../../Tagging/SalesOrderTagging";
import SoNotificationIcon from "../Common/Svg/SoNotificationIcon";
import SearchIcon from '../Common/Svg/SearchIcon';
import CloseButtonSmall from '../Common/Svg/CloseButtonSmall';
import Breadcrumb from '../Breadcrumbs/Breadcrumb';

const TrackSalesOrder = (_props) => {
  const context = useContext(SalesContext);

  const [showTrackingDetails, setShowTrackingDetails] = useState(false);
  const [salesData, setSalesData] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isTechnicalError, setIsTechnicalError] = useState(false);
  const [soErrorMsg, setSoErrorMsg] = useState(null);

  const [sonumber, setSonumber] = useState(
    {
      name: "Type SO number...",
      type: "input",
      value: '',
      validations: {
        required: true,
        minLength: 15,
        invalidMessage: "Please capture a valid Sales Order number",
        type: "salesOrderNumber"
      },
      config: {
        type: "text",
        required: true
      },
      isValid: false,
      isTouched: false
    }
  );

  const soNumberHandler = (event) => {
    const changedComponent = { ...sonumber };
    changedComponent.value = event.target.value.trim();
    changedComponent.isValid = checkInputValidity(changedComponent.value, changedComponent.validations);
    changedComponent.isTouched = true;
    setSonumber(changedComponent);
  }

  const getSalesOrderDetails = () => {
    setSoErrorMsg(null);
    context.setShowSpinner(true);
    getSalesOrderDetais(sonumber.value.trim().toUpperCase()).then(res => {
      // Success
      setSalesData(res.result);
      setIsError(false);
      setIsTechnicalError(false);
      setShowTrackingDetails(true);
      tagOnSODetailsPageLoad();
      context.setShowSpinner(false);
    })
      .catch(error => {
        // Failure
        setIsError(true);
        if (error?.status === 500) {
          setIsTechnicalError(true);
          error?.message ? setSoErrorMsg(error?.message)  : setSoErrorMsg("An error occurred. Please try again later");
          tagOnSOTechnicalError();
        } else {
          error?.data?.result?.message ? setSoErrorMsg(error?.data?.result?.message) : setSoErrorMsg("An error occurred. Please try again later");
          tagOnSODetailsPageErrorLoad();
        }
        setShowTrackingDetails(false);
        context.setShowSpinner(false);
      })
  }

  useEffect(() => {
    tagOnSOPageLoad();
  }, [])

  function clearSearch() {
    setShowTrackingDetails(false);
    setSonumber(
      {
        name: "Type SO number...",
        type: "input",
        value: '',
        validations: {
          required: true,
          minLength: 15,
          invalidMessage: "Please capture a valid Sales Order number",
          type: "salesOrderNumber"
        },
        config: {
          type: "text",
          required: true
        },
        isValid: false,
        isTouched: false
      }
    );
  }

  return (
    <React.Fragment>
      <Breadcrumb currentPath={"TRACKSALESORDER"} currentPathTitle={"Track my order"}></Breadcrumb>
      <div>
        {
          soErrorMsg ?
            <div className="so-error-banner-wrapper">
              <div className="so-error-banner-leftsection">
                <div className="so-notification-icon-wrapper"><SoNotificationIcon/></div>
                <div>{soErrorMsg}</div>
              </div>
              <div 
                className="so-error-banner-rightsection"
                onClick={()=> setSoErrorMsg(null)}
              >Dismiss</div>
            </div>
            :
            null
        }
      </div>

      <div className="so-main-container">
        <div  className="track-sales-order-header-wrapper">
          <div className="track-sales-order-header">
            Track your Vodacom Fibre order
          </div>
          <div className="track-sales-order-header-text">
            Want to know the status of your order? To track it, enter the sales order number or quote number that was emailed to you.
          </div>
          <div className="track-sales-order-input">
            <div className={
              sonumber.value && !sonumber.isValid ? "track-sales-order-search-wrapper red-border" : "track-sales-order-search-wrapper"}>
              <div className="track-sales-order-search-icon">
                <SearchIcon></SearchIcon>
              </div>
              <input
                  id="soNumberInput"
                  className="track-sales-order-search-field-input"
                  type="text"
                  placeholder="Enter Sale order or Quote number"
                  value={sonumber.value}
                  onChange={soNumberHandler}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && sonumber.isValid) {
                      getSalesOrderDetails();
                    }
                  }}
                  disabled={showTrackingDetails}
              />
              {
                showTrackingDetails ?
                  <div className="track-sales-order-close-button" onClick={() => {clearSearch()}}><CloseButtonSmall></CloseButtonSmall></div>
                :
                  null
              }
            </div>
            {
              !showTrackingDetails ?
                <button className="track-sales-order-search-button" disabled={!sonumber.isValid} onClick={() => {getSalesOrderDetails();}}>
                  Search
                </button>
              :
                null
            }
          </div>
        </div>
        <div>
          {
            showTrackingDetails && sonumber.isValid  ?
              <TrackingDetails
                close={() => { tagOnSOPageLoad(); setShowTrackingDetails(!showTrackingDetails) }}
                salesOrderData={salesData}
                isError={isError}
                isTechnicalError={isTechnicalError}
                soNumber={sonumber.value}
              />
              :
              null
          }
        </div>
      </div>
    </React.Fragment>

  )
}

export default TrackSalesOrder;